export default __webpack_public_path__ + "static/media/MyContacts.9188b40d.svg";